/**
 * Code for MSH Recent Viewed Page Module
 */
import $ from "jquery";

var filter = $("#recent-viewed-pages-filter");
InitRecentViewedPagesFilter();
InitRecentViewedPagesViewMore();

function InitRecentViewedPagesFilter() {
    if (filter && filter.length > 0) {
        filter.on("change", function () {
            RecentViewedPagesFilter(false);
        });
    }
}

function InitRecentViewedPagesViewMore() {
    $("#recent-viewed-pages-viewmore").on("click", function () {
        RecentViewedPagesFilter(true);
    });
}

function RecentViewedPagesFilter(isViewMore) {
    $.ajax({
        url: '/recentviewedpages/filterpages/',
        data: { filter: filter.val(), currentPageSize: $("#recent-viewed-pages-currentpagesize").val(), isViewMore: isViewMore },
        success: function (resp) {
            if (resp) {
                if (resp.Success) {
                    $('.recent-viewed-pages-listing').html(resp.Data.Html.Result);
                    $('.recent-viewed-pages-listing').foundation();
                    lozadObserver();
                    window.highlightLikeButtons($(".recent-viewed-pages-listing .like-button"));
                    InitRecentViewedPagesViewMore();
                }
            }
        }
    })
}